import { render } from "./PaymentMethods.vue?vue&type=template&id=4005e354&scoped=true"
import script from "./PaymentMethods.vue?vue&type=script&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&lang=js"

import "./PaymentMethods.vue?vue&type=style&index=0&id=4005e354&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4005e354"]])

export default __exports__